function olgcCopyTextFallback(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  textarea.remove();
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest?.('[data-olgc-offer-copy-code]');
  if (!button) return;

  const code = button.getAttribute('data-olgc-offer-copy-code') || '';
  const label = button.querySelector('[data-copy-label]');
  const defaultLabel = label?.textContent || 'Copy';
  if (!code) return;

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(code);
    } else {
      olgcCopyTextFallback(code);
    }

    button.classList.add('is-copied');
    if (label) label.textContent = 'Copied';
  } catch (error) {
    if (label) label.textContent = 'Copy failed';
  }

  window.setTimeout(() => {
    button.classList.remove('is-copied');
    if (label) label.textContent = defaultLabel;
  }, 1600);
});

(() => {
  const accountModalStyle = `
    dialog.dialog {
      position: fixed !important;
      inset: 50% auto auto 50% !important;
      width: min(432px, calc(100vw - 32px)) !important;
      max-height: calc(100dvh - 40px) !important;
      margin: 0 !important;
      transform: translate(-50%, -50%) !important;
    }

    dialog.dialog::backdrop {
      background: rgb(0 0 0 / 0.48) !important;
    }

    .account {
      max-height: calc(100dvh - 40px) !important;
      overflow-y: auto !important;
    }

    @media (max-width: 639px) {
      dialog.dialog {
        width: min(432px, calc(100vw - 24px)) !important;
        max-height: calc(100dvh - 24px) !important;
      }

      .account {
        max-height: calc(100dvh - 24px) !important;
      }
    }
  `;

  const updateAccountModalScrollState = () => {
    const isOpen = Array.from(document.querySelectorAll('shopify-account')).some((account) => (
      account.shadowRoot?.querySelector('dialog[open]')
    ));

    document.documentElement.classList.toggle('olgc-account-modal-open', isOpen);
  };

  const hideShopLogin = () => {
    document.querySelectorAll('shopify-account').forEach((account) => {
      const root = account.shadowRoot;
      if (!root) return;

      let style = root.querySelector('#olgc-account-modal-style');
      if (!style) {
        style = document.createElement('style');
        style.id = 'olgc-account-modal-style';
        style.textContent = accountModalStyle;
        root.appendChild(style);
      }

      root.querySelectorAll('shop-login').forEach((shopLogin) => {
        shopLogin.style.setProperty('display', 'none', 'important');
        shopLogin.style.setProperty('visibility', 'hidden', 'important');
      });

      root.querySelectorAll('shopify-login-form').forEach((loginForm) => {
        loginForm.shadowRoot?.querySelectorAll('.login-form__divider').forEach((divider) => {
          divider.style.setProperty('display', 'none', 'important');
          divider.style.setProperty('visibility', 'hidden', 'important');
        });

        if (loginForm.shadowRoot && !loginForm.shadowRoot.__olgcShopLoginObserver) {
          loginForm.shadowRoot.__olgcShopLoginObserver = new MutationObserver(hideShopLogin);
          loginForm.shadowRoot.__olgcShopLoginObserver.observe(loginForm.shadowRoot, { childList: true, subtree: true });
        }
      });

      if (!root.__olgcShopLoginObserver) {
        root.__olgcShopLoginObserver = new MutationObserver(hideShopLogin);
        root.__olgcShopLoginObserver.observe(root, { childList: true, subtree: true });
      }
    });

    updateAccountModalScrollState();
  };

  document.addEventListener('DOMContentLoaded', hideShopLogin);
  window.addEventListener('load', hideShopLogin);
  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('shopify-account')) return;

    requestAnimationFrame(hideShopLogin);
    window.setTimeout(hideShopLogin, 150);
  });

  new MutationObserver(hideShopLogin).observe(document.documentElement, { childList: true, subtree: true });
  [0, 250, 1000, 2500].forEach((delay) => window.setTimeout(hideShopLogin, delay));
})();



(() => {
  const offerSelector = '.product__info .mpb-offer.mpb-offer--quantity_discount';
  const wholePriceFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  const decimalPriceFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  function parseMoney(text) {
    const match = text?.match(/₹\s*([\d,]+(?:\.\d{1,2})?)/);
    return match ? Number(match[1].replace(/,/g, '')) : null;
  }

  function getCurrentProductPrice() {
    const priceElement = document.querySelector('.product__info [id^="Price-"], .product__info .price');
    return parseMoney(priceElement?.textContent || '');
  }

  function parseDiscount(text) {
    const match = text?.match(/(\d+(?:\.\d+)?)\s*%/);
    return match ? Number(match[1]) : 0;
  }

  function parseMinimumQuantity(text, index) {
    const match = text?.match(/\d+/);
    return match ? Number(match[0]) : index + 1;
  }

  function formatMoney(value) {
    const roundedValue = Math.round(value * 100) / 100;
    const formatter = Number.isInteger(roundedValue) ? wholePriceFormatter : decimalPriceFormatter;
    return formatter.format(roundedValue).replace('₹', '₹ ');
  }

  function getQuantity() {
    const input = getQuantityInput();
    return Number(input?.value || 1) || 1;
  }

  function getQuantityInput() {
    return document.querySelector('.product__info [name="quantity"]');
  }

  function setProductQuantity(quantity) {
    const input = getQuantityInput();
    if (!input || !quantity) return;

    input.value = String(quantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    scheduleEnhanceOffers();
  }

  function updateHint(offer, tiers) {
    let hint = offer.querySelector('.olgc-mpb-hint');
    if (!hint) {
      hint = document.createElement('div');
      hint.className = 'olgc-mpb-hint';
      offer.querySelector('.mpb-offer__tier-list')?.after(hint);
    }

    const quantity = getQuantity();
    const nextTier = tiers.find((tier) => tier.minimumQuantity > quantity && tier.discount > 0);
    if (nextTier) {
      const needed = nextTier.minimumQuantity - quantity;
      hint.textContent = `${needed} more ${needed === 1 ? 'piece' : 'pieces'} unlocks ${nextTier.discount}% off per piece`;
      return;
    }

    const unlockedTier = [...tiers].reverse().find((tier) => quantity >= tier.minimumQuantity && tier.discount > 0);
    hint.textContent = unlockedTier ? `${unlockedTier.discount}% off per piece is active` : 'Select a set size to see your per-piece offer';
  }

  function updateBulkCta(offer) {
    if (offer.querySelector('.olgc-mpb-bulk')) return;

    const bulkCta = document.createElement('div');
    bulkCta.className = 'olgc-mpb-bulk';
    bulkCta.innerHTML = `
      <span><strong>Ordering 15 or more?</strong><small>Corporate gifting, event orders & gift-ready packaging</small></span>
      <button type="button" data-olgc-mpb-bulk-modal-open>Get bulk pricing →</button>
    `;
    offer.append(bulkCta);
  }

  function closeBulkModal(modal, returnTarget) {
    modal.hidden = true;
    document.documentElement.classList.remove('olgc-bulk-modal-open');
    returnTarget?.focus();
  }

  function prepareBulkModal(modal, returnTarget) {
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    if (modal.dataset.olgcMpbModalReady) return;

    modal.querySelectorAll('[data-olgc-bulk-modal-close]').forEach((button) => {
      button.addEventListener('click', () => closeBulkModal(modal, returnTarget));
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeBulkModal(modal, returnTarget);
    });

    modal.dataset.olgcMpbModalReady = 'true';
  }

  function openBulkModal(trigger) {
    const modal = document.querySelector('[data-olgc-bulk-modal]');
    if (!modal) return;

    prepareBulkModal(modal, trigger);
    modal.hidden = false;
    document.documentElement.classList.add('olgc-bulk-modal-open');
    modal.querySelector('.olgc-bulk-modal__close')?.focus();
  }

  function moveOfferBelowDelivery(offer) {
    const deliveryCard = document.querySelector('.product__info .olgc-delivery-card');
    if (!deliveryCard || deliveryCard.nextElementSibling === offer) return;

    deliveryCard.insertAdjacentElement('afterend', offer);
  }

  function removeGrouptifyBadge() {
    document.querySelectorAll('.product__info img[alt="Grouptify"][src*="G_Bundles_2.png"]').forEach((image) => {
      const wrapper = image.parentElement;
      if (wrapper?.getAttribute('title') === 'Powered by Grouptify') {
        wrapper.remove();
        return;
      }

      image.remove();
    });
  }

  function enhanceOffer(offer) {
    const basePrice = getCurrentProductPrice();
    const title = offer.querySelector('.mpb-offer__title');
    const tierItems = Array.from(offer.querySelectorAll('.mpb-offer__tier-item'));
    const currentQuantity = getQuantity();
    const tiers = tierItems.map((tier, index) => {
      const titleElement = tier.querySelector('.mpb-offer__tier-item__title');
      const badgeElement = tier.querySelector('.mpb-offer__tier-item__badge');
      const discount = parseDiscount(badgeElement?.textContent || '');
      const tierPrice = basePrice ? basePrice * (1 - discount / 100) : null;
      const minimumQuantity = parseMinimumQuantity(titleElement?.textContent || '', index);
      const nextTitleElement = tierItems[index + 1]?.querySelector('.mpb-offer__tier-item__title');
      const nextMinimumQuantity = nextTitleElement ? parseMinimumQuantity(nextTitleElement.textContent || '', index + 1) : Infinity;

      tier.classList.toggle('olgc-mpb-popular', index === 1);
      tier.classList.toggle('olgc-mpb-best', index === tierItems.length - 1);
      tier.classList.toggle('olgc-mpb-active', currentQuantity >= minimumQuantity && currentQuantity < nextMinimumQuantity);
      tier.dataset.olgcQuantity = String(minimumQuantity);
      tier.setAttribute('role', 'button');
      tier.setAttribute('tabindex', '0');
      tier.setAttribute('aria-pressed', currentQuantity >= minimumQuantity && currentQuantity < nextMinimumQuantity ? 'true' : 'false');

      let priceElement = tier.querySelector('.olgc-mpb-tier-price');
      if (!priceElement) {
        priceElement = document.createElement('div');
        priceElement.className = 'olgc-mpb-tier-price';
        titleElement?.after(priceElement);
      }

      if (tierPrice) {
        const priceMarkup = `<strong>${formatMoney(tierPrice)}</strong><span>/pc</span>`;
        if (priceElement.innerHTML !== priceMarkup) priceElement.innerHTML = priceMarkup;
      }

      return {
        discount,
        minimumQuantity
      };
    });

    offer.classList.add('olgc-mpb-enhanced');
    moveOfferBelowDelivery(offer);
    if (title) title.textContent = 'Gift more, Save More';
    updateHint(offer, tiers);
    updateBulkCta(offer);
  }

  function enhanceOffers() {
    removeGrouptifyBadge();
    document.querySelectorAll(offerSelector).forEach(enhanceOffer);
  }

  let enhanceQueued = false;
  function scheduleEnhanceOffers() {
    if (enhanceQueued) return;
    enhanceQueued = true;

    requestAnimationFrame(() => {
      enhanceQueued = false;
      enhanceOffers();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleEnhanceOffers);
  document.addEventListener('change', (event) => {
    if (event.target.matches('.product__info [name="quantity"]')) scheduleEnhanceOffers();
  });
  document.addEventListener('click', (event) => {
    const bulkModalTrigger = event.target.closest('[data-olgc-mpb-bulk-modal-open]');
    if (bulkModalTrigger) {
      event.preventDefault();
      openBulkModal(bulkModalTrigger);
      return;
    }

    const tier = event.target.closest('.product__info .mpb-offer__tier-item[data-olgc-quantity]');
    if (tier) {
      setProductQuantity(Number(tier.dataset.olgcQuantity));
      return;
    }

    if (event.target.closest('.product__info .quantity__button')) {
      setTimeout(scheduleEnhanceOffers, 200);
    }
  });
  document.addEventListener('keydown', (event) => {
    const tier = event.target.closest?.('.product__info .mpb-offer__tier-item[data-olgc-quantity]');
    if (!tier || (event.key !== 'Enter' && event.key !== ' ')) return;

    event.preventDefault();
    setProductQuantity(Number(tier.dataset.olgcQuantity));
  });

  scheduleEnhanceOffers();
  new MutationObserver(scheduleEnhanceOffers).observe(document.documentElement, { childList: true, subtree: true });
})();

if (!customElements.get('olgc-gallery-limit')) {
  customElements.define('olgc-gallery-limit', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.slider = this.gallery?.querySelector('slider-element');
      this.list = this.slider?.querySelector('.product__media-list');
      if (!this.list) return;

      this.moreLabel = this.querySelector('template')?.content.querySelector('span').cloneNode(true);
      this.refresh = this.refresh.bind(this);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.list, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
      this.refresh();
    }

    refresh() {
      const items = Array.from(this.list.children).filter((item) => item.matches('.product__media'));
      const eligible = items.filter((item) => !item.hidden
        && !(item.classList.contains('product__media--variant') && item !== this.list.firstElementChild));
      const limit = Number(this.dataset.limit) || 4;
      const extra = new Set(eligible.slice(limit));
      items.forEach((item) => item.toggleAttribute('data-olgc-grid-extra', extra.has(item)));
      if (this.moreLabel) {
        if (extra.size > 0) {
          const label = this.dataset.moreLabel.replace('__COUNT__', String(extra.size));
          if (this.moreLabel.textContent !== label) this.moreLabel.textContent = label;
          const lastVisible = eligible[limit - 1];
          if (this.moreLabel.parentElement !== lastVisible) lastVisible.appendChild(this.moreLabel);
        } else {
          this.moreLabel.remove();
        }
      }
      this.slider.reset?.();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.moreLabel?.remove();
      this.list?.querySelectorAll('[data-olgc-grid-extra]').forEach((item) => item.removeAttribute('data-olgc-grid-extra'));
    }
  });
}
